import { render, staticRenderFns } from "./creatOrder.vue?vue&type=template&id=42440af6&scoped=true"
import script from "./creatOrder.vue?vue&type=script&lang=js"
export * from "./creatOrder.vue?vue&type=script&lang=js"
import style0 from "./creatOrder.vue?vue&type=style&index=0&id=42440af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42440af6",
  null
  
)

export default component.exports